import React, { useEffect, useState } from "react";
import CustomTable from "../../Components/Table";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  allApprovedJobsColumns,
  allPendingJobsColumns,
  allRejectedJobsColumns,
  allArchivedJobsColumns,
} from "../../Utils/tableData";
import { getAllJobs } from "../../Redux/Slices/JobSlice";
import JobDrawer from "../../Components/JobDrawer";
import JobsFeed from "./JobsFeed";
import { Segmented } from "antd";
import { AppstoreOutlined, TableOutlined } from "@ant-design/icons";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Jobs = () => {
  const { editJob } = useSelector((state) => state.DialogSlice);
  const { jobs, loading, updateLoading, total } = useSelector(
    (state) => state.JobSlice
  );
  // * A notification deep link carries ?status=pending. Without this the tab
  // * is restored from localStorage and the job the admin was sent to look at
  // * is not in the list they land on. * //
  const [searchParams] = useSearchParams();
  const linkedStatus = searchParams.get("status");
  const localStatus = localStorage.getItem("jobsListStatus");
  const [status, setStatus] = useState(
    linkedStatus || (localStatus ? localStatus : "approved")
  );

  useEffect(() => {
    if (linkedStatus && linkedStatus !== status) {
      setStatus(linkedStatus);
      localStorage.setItem("jobsListStatus", linkedStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkedStatus]);
  // * Table to manage jobs, Preview to read every job as its card. Remembered
  // * between visits like the status tab. * //
  const [view, setView] = useState(
    localStorage.getItem("jobsView") === "preview" ? "preview" : "table"
  );
  const handleView = (value) => {
    setView(value);
    localStorage.setItem("jobsView", value);
  };
  const [limit, setLimit] = useState(10);
  // const[page,setPage]=useState(1)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pageNumber } = useParams();

  const pagination = {
    total,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    current: pageNumber,
    pageSize: limit,
    onChange: (newPage) => {
      localStorage.setItem("jobsPage", newPage);
      // setPage(newPage);
      navigate(`/dashboard/jobs/${newPage}`);
    },
    onShowSizeChange: (e, value) => setLimit(value),
  };
  const handleStatus = (e) => {
    // setPage(1);
    setStatus(e.target.value);
    localStorage.setItem("jobsListStatus", e.target.value);
    navigate(`/dashboard/jobs/1`);
  };
  useEffect(() => {
    // * The preview loads its own jobs; only the table needs this page. * //
    if (view !== "table") return;
    dispatch(
      getAllJobs({
        status,
        page: pageNumber,
        limit,
        archived: status === "archived",
      })
    );
    // * limit too: changing the page size kept the old size's rows, so
    // * "20 per page" still showed 10 and page 2 skipped ahead. * //
  }, [status, editJob?.open, pageNumber, view, limit]);
  const columnsToRender = () => {
    switch (status) {
      case "approved":
        return allApprovedJobsColumns;
      case "pending":
        return allPendingJobsColumns;
      case "rejected":
        return allRejectedJobsColumns;
      case "archived":
        return allArchivedJobsColumns;
      default:
        return allApprovedJobsColumns;
    }
  };
  return (
    <div className="jobs-container">
      <div className="job-container-header">
        <CustomTable
          title="Manage jobs"
          dataSource={jobs}
          columns={columnsToRender()}
          loading={loading || updateLoading}
          renderTabsJobs
          status={status}
          handleStatus={handleStatus}
          pagination={pagination}
          isJob
          headerExtra={
            <Segmented
              value={view}
              onChange={handleView}
              options={[
                { label: "Table", value: "table", icon: <TableOutlined /> },
                { label: "Preview", value: "preview", icon: <AppstoreOutlined /> },
              ]}
            />
          }
          body={view === "preview" ? <JobsFeed status={status} /> : null}
        />
        <JobDrawer />
      </div>
      <ToastContainer />
    </div>
  );
};

export default Jobs;
